import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { select, Store } from '@ngrx/store';

import { FeatureType } from '../../shared/generated';
import { FeatureService } from '../../shared/generated/api/feature.service';
import { filterTruthy } from '../../shared/rxjs/utils';
import { SharedSelectors } from '../../shared/store/shared.selector';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-home',
  imports: [RouterLink],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly destroyRef = inject(DestroyRef);
  private readonly featureService = inject(FeatureService);

  featureTypes: FeatureType[] = [];
  readonly FeatureType = FeatureType;
  isComplaint0KmEnabled = false;
  isPocFormEnabled = false;

  ngOnInit() {
    this.getFeatureTypesFromStore();
    this.featureService.apiFeaturesKeyGet('Complaint0Km').subscribe({
      next: (enabled: boolean) => (this.isComplaint0KmEnabled = enabled),
      error: () => (this.isComplaint0KmEnabled = false)
    });
    this.featureService.apiFeaturesKeyGet('PocForm').subscribe({
      next: (enabled: boolean) => (this.isPocFormEnabled = enabled),
      error: () => (this.isPocFormEnabled = false)
    });
  }

  getFeatureTypesFromStore() {
    this.store
      .pipe(
        select(SharedSelectors.featureTypes),
        filterTruthy(),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((featureTypes) => {
        this.featureTypes = featureTypes;
      });
  }
}
